import React from 'react';
import _ from 'lodash';

import * as YVS from 'components/line-items/controls/year-values-styles';
import YearColumn from 'components/line-items/controls/year-column';

import propertyService from "data/property"
import { parseDate } from "data/lib/dates"

export default class YearValues extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allYearsData: this.props.allYearsData,
      isCascadeUpdate: false,
      isDirty: false
    }
  }

  componentWillReceiveProps(nextProps) {
    // only update the internal state of the year values from props if the number of years has changed
    if(nextProps.allYearsData.length !== this.state.allYearsData.length || nextProps.none) {
      this.setState({allYearsData: nextProps.allYearsData});
    }
  }

  getAnalysisBeginDate = () => {
    const currentProperty = propertyService.get()
    return parseDate(_.get(currentProperty, 'analysisbegindate'));
  }

  labelColumn = () => {
    const analysisBeginDate = this.getAnalysisBeginDate();
    let   currentMonth      = analysisBeginDate.month();
    const monthNames        = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    let   labelColumn       = [];
    for (let i=0; i < 12; i++){
      labelColumn.push(<div className="month-label" key={`month-label-${i}`}>{`${monthNames[currentMonth]}`}</div>);
      currentMonth += 1
      if (currentMonth === 12) currentMonth = 0;
    }
    labelColumn.push(<div className="month-label">{this.props.isPercent ? 'Average' : 'Total'}</div>);
    return labelColumn;
  }

  updateYear = (yearData, callback) => {
    const yearIndex = yearData.year - 1;
    const updated = [...this.state.allYearsData];
    updated.splice(yearIndex, 1, yearData);
    this.setState({allYearsData: updated, isDirty: true}, () => {
      this.props.handleUpdate(this.state.allYearsData)
      if(callback && typeof callback === 'function') callback()
    });
  }

  cascadeValuesRight = yearData => {
    const startIndex = yearData.year;
    const updated = [...this.state.allYearsData];
    updated[startIndex - 1] = yearData;
    for(let i = startIndex; i < updated.length; i++) {
      const copyData = Object.assign({}, yearData);
      copyData.year = i + 1;
      updated[i] = copyData;
    }
    this.setState({allYearsData: updated, isCascadeUpdate: true, isDirty: true},
      () => this.setState({isCascadeUpdate: false},
        () => this.props.handleUpdate(this.state.allYearsData)));
  }

  render() {
    const yearColumns = this.state.allYearsData.map((year, i) => {
      const isLast = (i+1) === this.state.allYearsData.length ? true : false;
      const isPercent = this.props.isPercent
      return <YearColumn
              yearData={year}
              isLastColumn={isLast}
              isPercent={isPercent}
              cascadeValuesRight={this.cascadeValuesRight}
              isCascadeUpdate={this.state.isCascadeUpdate}
              lastFieldTabHandler={this.props.lastFieldTabHandler}
              updateYear={this.updateYear}
              none={this.props.none}
              reset={this.props.reset}
              key={`year-column-${i}`}
              analysisBeginDate={this.getAnalysisBeginDate()}
              ref={column => this[`y${i+1}`] = column}
              yearNum={i}
              attrs={this.props.attrs}
              />;
    });

    return (
      <YVS.YearValuesContainer id="year_values_container" ref={container => this.container = container}>
        <div className="label-column">
          { this.labelColumn() }
        </div>
        <YVS.YearValueColumnContainer>
          { yearColumns }
        </YVS.YearValueColumnContainer>
      </YVS.YearValuesContainer>
    );
  }
}
